<template>
  <div>
    <Head title="Tasks" />
    <h1 class="mb-8 font-bold text-3xl w-full">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/contacts"> Contacts </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="'/contacts/'+contact.id+'/edit'"> {{ contact.first_name }} {{ contact.last_name }}</Link>
      <span class="text-indigo-400 font-medium"> / </span> Tasks
    </h1>
    <div class="flex flex-wrap items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md w-full" @reset="reset">
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Type:</label>
          <select v-model="form.typeFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="email">Email</option>
            <option value="reminder">Reminder</option>
            <option value="text">SMS</option>
            <option value="voicemail">Voicemail</option>
          </select>
        </div>
      </search-filter>
      <!-- <Link class="btn-indigo" href="/contacts/{contact.id}/task/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Task</span>
      </Link> -->
      <div class="inline-flex gap-2 py-4 flex flex-wrap justify-between gap-2">
        <TaskContact :contact="contact" />
        <TaskAutomationContact :contact="contact" :campaigns="campaigns" />
        <!-- <button class="btn-indigo font-normal w-40" @click="deleteAutomationTasks()">Delete Automations</button> -->
        <button class="btn-indigo font-normal w-40 cursor-pointer text-white bg-gray-600 hover:bg-gray-800" @click="deleteAll()">Delete All Tasks</button>
      </div>
    </div>
    <div v-for="(task, index) in tasks" :key="task.id" class="max-w-screen-xl m-auto">
      <div class="w-full text-white">
        <div class="flex justify-center">
          <div v-if="index == 0" class="relative">
            <div class="w-12 h-12 absolute top-4/4 md:top-4/4 -mt-6 -ml-3 rounded-full bg-blue-900 shadow text-white">
              <div class="text-s absolute top-1/2 -mt-2 ml-4">
                <span v-html="buttonType(task.type)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full text-white">
        <div class="flex justify-center">
          <span v-if="index > 0" class="py-6 md:py-20" />
          <div v-if="index > 0" class="relative">
            <div class="h-full w-6 flex items-center justify-center">
              <div class="h-full w-1 bg-blue-800 pointer-events-none" />
            </div>
            <div class="hidden md:block w-48 h-12 absolute top-1/2 -mt-6 -ml-20 rounded-full bg-blue-900 shadow text-center">
              <div class="text-center pt-4">{{ task.delay }}</div>
            </div>
            <div class="w-12 h-12 absolute top-4/4 md:top-4/4 -mt-6 -ml-3 rounded-full bg-blue-900 shadow text-white">
              <div class="text-s absolute top-1/2 -mt-2 ml-4">
                <span v-html="buttonType(task.type)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-3xl shadow overflow-x-auto">
        <div :id="task.id" class="w-full flex flex-wrap text-center">
          <div class="w-full py-3 px-6">
            <div class="py-4 flex justify-between">
              <div class="text-center w-full lg:w-1/8">
                <div class="text-6xl text-blue-900">
                  <span v-html="buttonType(task.type)" />
                </div>
                <div class="text-xl text-center">
                  {{ task.type }}
                </div>
              </div>
              <div class="text-xl w-full lg:w-6/8 p-4">
                <span class="text-xl font-bold text-center text-indigo-600">{{ datestamp(task.trigger_time) }} at {{ timestamp(task.trigger_time) }}</span>
              </div>
              <div class="text-l font-bold text-center w-full lg:w-1/8">
                <div class="mb-2">Campaign: {{ task.campaign_name ? task.campaign_name = task.campaign_name : 'None' }}</div>
                <div v-if="task.user.first_name || task.user.last_name">Scheduled By: {{ task.user.first_name ? task.user.first_name : ''  }} {{ task.user.last_name ? task.user.last_name : ''  }}</div>
              </div>
            </div>
            <div class="w-full text-lg">
              <div v-if="task.subject && (task.type == 'voicemail')" class="pb-4">
                <span class="font-bold">Voicemail to be Delivered:</span> {{ strippedContent(task.subject) }}
              </div>
              <div v-if="!(task.type == 'status' || task.type == 'voicemail')">
                <span v-if="['text', 'email', 'reminder'].includes(task.type)" class="font-bold">Message: </span> 
                <span v-html="task.message" />
                <div class="pb-4 w-full flex justify-center items-center">
                  <img v-if="isImage(task.attachment)" :src="task.attachment" class="max-w-xs max-h-xs" />
                  <span v-if="!isImage(task.attachment) && task.attachment" class="pt-4 text-sm"><i class="fas fa-paperclip"></i> Item Attached</span>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full flex py-3 px-6 items-center">
            <div class="hidden md:block mr-auto text-md font-normal text-gray-600 ml-10">
                <span v-if="task.stop_on_reply" class="mr-10"><i class="fas fa-ban"></i> Stop on Reply</span>
            </div>
            <TaskEdit :task="task" class="ml-4">
              <template #buttonTop>
                <button class="cursor-pointer order-last place-items-end inline-flex items-right px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-gray-600"> Edit </button>
              </template>
            </TaskEdit>
            <div class="ml-4">
              <button class="cursor-pointer order-last place-items-end inline-flex items-right px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-400 hover:bg-gray-800" @click="destroyTask(task.id)"> Delete Task </button>
            </div>
            <div v-if="task.campaign_id" class="ml-4">  
              <button class="cursor-pointer order-last place-items-end inline-flex items-right px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-600 hover:bg-gray-800" @click="destroyCampaign(task.campaign_id)"> Delete Campaign</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tasks.length < 1">
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <div class="w-full flex flex-wrap text-center">
          <div class="w-full py-3 px-6">
            <div class="py-4 whitespace-nowrap">
              <h1 class="font-bold font-gray-800 text-3xl w-full text-center justify-center">No Tasks</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import moment from 'moment'
import TaskContact from '@/Shared/TaskContact'
import TaskAutomationContact from '@/Shared/TaskAutomationContact'
import TaskEdit from '@/Shared/TaskEdit'

export default {
  components: {
    Head,
    Link,
    SearchFilter,
    TaskContact,
    TaskEdit,
    TaskAutomationContact,
  },
  layout: Layout,
  props: {
    filters: Object,
    tasks: Array,
    contact: Object,
    campaigns: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search
      },
    }
  },
  computed:{

  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        router.get('/contacts/'+this.contact.id+'/tasks', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    strippedContent(value) {
      let regex = /(<([^>]+)>)/ig;
      return value.replace(regex, '')
    },
    timestamp : function (date) {
      return moment(date).format('h:mm A')
    },
    datestamp : function (date) {
      return moment(date).format('MM/DD/YY')
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    buttonType(type) {
      if(type == 'reminder'){
        type = '<i class="fas fa-user-clock" />'
      }
      else if(type == 'text'){
        type = '<i class="fas fa-sms" />'
      }
      else if(type == 'email'){
        type = '<i class="fas fa-envelope" />'
      }
      else if(type == 'voicemail'){
        type = '<i class="fas fa-voicemail" />'
      }
      else if (type == 'tag') {
        type = '<i class="fas fa-tag"></i>'
      }
      return type
    },    
    isImage(url) {
      const imageExtensions = /\.(jpg|jpeg|png|gif)$/i;
      return imageExtensions.test(url);
    },
    destroyTask(id) {
      // router.delete(this.route('notes.destroy', id, { only: ['notes'] }))
      if (confirm('Are you sure you want to delete this task?')) {
        router.delete(('/tasks/'+id),{ only: ['tasks'], preserveScroll: true })
      }
    },
    destroyCampaign(id) {
      if (confirm('Are you sure you want to delete all tasks for this campaign?')) {
        router.delete(('/contacts/'+this.contact.id+'/tasks/campaign/'+id+'/delete'),{ only: ['tasks'], preserveScroll: true })
      }
    },
    // deleteAutomationTasks() {
    //   if (confirm('Are you sure you want to delete all Automations for this contact?')) {
    //     router.delete('/contacts/'+this.contact.id+'/tasks/automations/delete',{ only: ['tasks'], preserveScroll: true })
    //   }
    // },
    deleteAll() {
      if (confirm('Are you sure you want to delete all Tasks for this contact?')) {
        router.delete('/contacts/'+this.contact.id+'/tasks/delete',{ only: ['tasks'], preserveScroll: true })
      }
    },
  },
}
</script>
